import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PessoaTelefoneService} from './pessoa-telefone.service';
import {PessoaTelefoneComponent} from './pessoa-telefone.component';
import {AppSharedModule} from '../app-shared.module';



@NgModule({
  declarations: [
    PessoaTelefoneComponent
  ],
  imports: [
    CommonModule,
    AppSharedModule
  ],
  exports: [
    PessoaTelefoneComponent
  ],
  providers: [
    PessoaTelefoneService
  ]
})
export class PessoaTelefoneModule { }
